"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBoolean = void 0;
const assertString_1 = require("./util/assertString");
const defaultOptions = { loose: false };
const strictBooleans = ['true', 'false', '1', '0'];
const looseBooleans = [...strictBooleans, 'yes', 'no'];
function isBoolean(str, options = defaultOptions) {
    (0, assertString_1.assertString)(str);
    if (options.loose) {
        return looseBooleans.includes(str.toLowerCase());
    }
    return strictBooleans.includes(str);
}
exports.isBoolean = isBoolean;
